import { CreditCard } from '@/lib/apollo/types/gen/graphql';

const brandRegexp = new RegExp(
  `^(${import.meta.env.VITE_CREDIT_CARD_BRAND_PATTERN})$`,
  'i',
);

class CreditCardSelector {
  private creditCard: CreditCard;

  constructor(creditCard: CreditCard) {
    this.creditCard = creditCard;
  }

  /**
   * ポケットカードか判定
   */
  get isPcc() {
    return this.creditCard.denominationCode.startsWith('PCC');
  }

  /**
   * DMMカードか判定
   */
  get isPccDmm() {
    return this.creditCard.denominationCode.startsWith('PCCDMM');
  }

  /**
   * 利用可能か判定
   * 本番環境はVisaのみ可
   * STG環境はそれに加えてJCB
   * ポケットカードはMasterCard以外可
   */
  get isAvailable() {
    if (this.isPcc) {
      return this.creditCard.brandName !== 'Master';
    }
    return brandRegexp.test(this.creditCard.brandName);
  }
}

export const creditCardSelector = (creditCard?: CreditCard | null) => {
  return new CreditCardSelector(
    creditCard || {
      brandId: 0,
      brandName: '',
      denominationCode: '',
    },
  );
};
